import React from "react";
import { net } from "../../../database";
import { UserX } from "lucide-react";

/**
 * StopUserButton — Deactivates a user by setting status to 1.
 * Replaces MUI Button with a Tailwind-styled button.
 *
 * @author Forge (opencode + glm-5.1)
 * @date 2026-04-16
 * @version 2.0
 *
 * @param {Object} props
 * @param {string} props.id - User ID to stop
 * @param {function} props.result - Callback with the updated user object
 * @returns {React.ReactElement}
 */
export default function StopUserButton({ id, result }) {
  const stopUser = () => {
    net.post(`/user/${id}`, { status: 1, unreadNotifications: [] }).then((res) => {
      result(res);
    });
  };

  return (
    <button
      onClick={stopUser}
      className="flex items-center gap-1.5 px-3 py-1.5 bg-red-50 text-red-600 border border-red-200 rounded-lg text-sm font-semibold hover:bg-red-100 hover:border-red-300 active:bg-red-200 transition-all duration-150 cursor-pointer"
    >
      <UserX size={14} />
      Stop
    </button>
  );
}
